import { SelectNameValue } from 'business/models/CustomModels';
import { ImagingTab } from './types';

export enum EImagingTabOptions {
  Scheduling = 0,
  ImagingSettings = 1,
  ImageManagementTask = 2,
  ImagerQuota = 3,
}

export enum EImagingTabNames {
  Scheduling = 'Scheduling',
  ImagingSettings = 'Imaging Settings',
  ImageManagementTask = 'Image Management Task',
  ImagerQuota = 'Imager Quota',
}

export const imagingSetupTabs = [
  { key: EImagingTabOptions.Scheduling, value: 'scheduling' },
  { key: EImagingTabOptions.ImagingSettings, value: 'imagingsettings' },
  { key: EImagingTabOptions.ImageManagementTask, value: 'imagemanagementtask' },
  { key: EImagingTabOptions.ImagerQuota, value: 'imagerquota' },
];

export const IMAGING_SETUP_ROUTE = '/setup/imaging/:tab';

export const getImagingSetupPath = (tab: EImagingTabOptions): string =>
  IMAGING_SETUP_ROUTE.replace(
    ':tab',
    imagingSetupTabs.find((setupTab) => setupTab.key === tab).value,
  );

export const imagingTabs: ImagingTab[] = [
  {
    tabType: EImagingTabOptions.Scheduling,
    title: EImagingTabNames.Scheduling,
  },
  {
    tabType: EImagingTabOptions.ImagingSettings,
    title: EImagingTabNames.ImagingSettings,
  },
  {
    tabType: EImagingTabOptions.ImageManagementTask,
    title: EImagingTabNames.ImageManagementTask,
  },
  {
    tabType: EImagingTabOptions.ImagerQuota,
    title: EImagingTabNames.ImagerQuota,
  },
];

export type EditStatus = {
  isDirty?: boolean;
  isSaving?: boolean;
};

export type FetchStatus = {
  isLoading: boolean;
  refetch: boolean;
};

export type TableColumns = {
  accessor?: string | number;
  Header?: any;
  className?: string;
  Cell?: any;
  Filter?: Function;
  sortType?: string;
};

export const inputFieldStyle = {
  border: '1px solid black',
  borderRadius: '0.25rem',
};

export enum LevelingOptions {
  Off = 1,
  Manual = 2,
  Auto = 3,
}

export const levelingOptions: SelectNameValue[] = [
  { name: 'Off', value: LevelingOptions.Off },
  { name: 'Manual', value: LevelingOptions.Manual },
  { name: 'Auto', value: LevelingOptions.Auto },
];

export enum LimitOptions {
  lowerLevelLimit = 1,
  upperLevelLimit = 2,
}

export enum ImageSettingChecks {
  importFl = 1,
  enabled = 2,
}

export const opticsFields = [
  'Condenser',
  'Polarizer',
  'Fluoro Light',
  'Imaging Mode',
  'FRAP Mode',
];

export enum FieldTypes {
  None = 0, // Grouping, Label, Display
  Boolean = 1, // Boolean, Yes No, Male Female, True False.
  SingleOption = 2, // Radio Button or ComboBox
  MultipleOption = 3, // No one use it now. CheckBoxes, Multiselect.
  Numeric = 4, // Have Min Max
  Text = 5, // Free Text
  Special = 6, // No need implementation.
  Range = 7,
}

export enum FixedLightPathOptions {
  Disabled = 'Disabled',
}

export const disabledOption = {
  value: -1,
  label: FixedLightPathOptions.Disabled,
};

export const fieldType = {
  [FieldTypes.Numeric]: 'number',
  [FieldTypes.SingleOption]: 'select',
  [FieldTypes.Text]: 'text',
  [FieldTypes.Boolean]: 'checkbox',
  [FieldTypes.Range]: 'range',
};

export enum FrapModes {
  FullRecovery = 'FullRecovery',
  HighThroughput = 'HighThroughput',
}

export enum LightPathIds {
  'Disabled' = -1,
  'Visible' = 0,
  'Ultraviolet' = 1,
  'Fluorescence' = 1,
  'SONICC' = 2,
  'FRAP' = 3,
}

export const lightPathIdsLookup = {
  visible: LightPathIds.Visible,
  ultraviolet: LightPathIds.Ultraviolet,
  fluorescence: LightPathIds.Fluorescence,
  sonicc: LightPathIds.SONICC,
  frap: LightPathIds.FRAP,
};

export const getFrapIntervalOfImagesPropName = (prefix: string) =>
  `${prefix}FrapIntervalsOfImagesToTakeAfterLaserShot`;

export enum frapImagingModes {
  Default = 'Default',
  Fluorescence = 'Fluorescence',
  FRAP = 'FRAP',
}

export const frapPrefix = 'FRAP.';
export const fluorescenceModePropName = 'FluorescenceMode';
export const frapModePropName = 'FrapMode';
export const externalConfig = 'ExternalConfig';

export enum ActionRequestStatus {
  fulfilled = 'fulfilled',
  rejected = 'rejected',
}
